import type { CarbonScoreProduct } from '@/domains/sustainability/carbonScore/data/carbonScore.model';

const MIN_CARBON_SCORE_CONFIDENCE = 4;

export const isCarbonScoreRelevant = (carbonScoreProduct: CarbonScoreProduct) =>
  carbonScoreProduct.confidenceIndicator <= MIN_CARBON_SCORE_CONFIDENCE;
